/**
 * Normalizes symbols used for quote subscriptions and Redux quote keys.
 * US equity and OCC option symbols are conventionally uppercase. This removes
 * invalid duplicate casings (e.g. "Nflx" vs "NFLX") that can appear in API
 * payloads and cause duplicate subscriptions or bad merge behavior.
 */
export function normalizeQuoteSymbol(symbol: string): string {
  return symbol.trim().toUpperCase();
}
